<template>
    <div>
        <canvas ref="chart"></canvas>
    </div>
</template>

<script>
// import Chart from 'chart.js'

export default {
    props: {
        type: String, //['area', 'bar', 'bubble', 'pie', 'line']
        data: Object,
        options: Object

    },
    data: () => ({
        chart: null,
        defaultOptions: {
            responsive: true,
            maintainAspectRatio: true,
            aspectRatio: 1.5,
            onHover: function(event) {
                event.srcElement.style.cursor = 'default'
            },
            legend: {
                position: 'bottom',
                onHover: function(event, legendItem) {
                    if(legendItem) {
                        event.srcElement.style.cursor = 'pointer'
                    }
                }
            }
        }
    }),
    methods: {
        initChart(typeLabel) {
            if(this.chart && typeLabel) {
                this.chart.destroy()
            }
            this.chart = new Chart(this.$refs.chart, {
                type: this.$props.type || 'line',
                data: this.$props.data || {},
                options: this.$props.options || this.defaultOptions
            })
        }
    },
    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                this.initChart()
                $('#tiles').trigger('resize')
            }, 500) 
        })
    }
}
</script>

<style lang="sass" scoped>

</style>